import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTheme } from "../context/ThemeProvider";
import { useContent } from "../context/ContentProvider";
import { useBooking } from "../context/BookingContext";
import { getFullImageUrl } from "../utils/imageUtils";

const Header: React.FC = () => {
  const { theme } = useTheme();
  const { content } = useContent();
  const { selectedHotel } = useBooking();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedLang, setSelectedLang] = useState("FR");

  // Ref for the dropdown
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Handle click outside to close the dropdown
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <header
      className="py-6 px-6 z-10"
      style={{ backgroundColor: "var(--hotel-card-background-color)" }}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div></div>
        {/* Hotel Logo */}
        <div className="flex items-center">
          <Link to={`/${selectedHotel?.slug || 'hotel-adriatica'}`} className="flex items-center">
            {theme.logoUrl ? (
              <img
                src={getFullImageUrl(theme.logoUrl)}
                alt={content.welcomeTitle || "Hotel Logo"}
                className="h-28 w-auto"
                onError={(e) => {
                  console.warn(
                    "Failed to load custom logo, falling back to default"
                  );
                  (e.target as HTMLImageElement).src = "/logo-header.svg";
                }}
              />
            ) : (
              <img
                src="/logo-header.svg"
                alt={content.welcomeTitle || "Hôtel Adriatica Logo"}
                className="h-28    w-auto"
              />
            )}
          </Link>
        </div>

        {/* Right Side - Language Selector */}
        <div className="flex items-center">
          {/* Language Selector */}
          <div className="relative" ref={dropdownRef}>
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="flex items-center space-x-1 px-3 py-2 border rounded-md hover:bg-gray-50 transition-colors"
              style={{
                fontFamily: "var(--hotel-body-font-family)",
                color: "var(--hotel-primary-color)",
                borderColor: "var(--hotel-primary-color)",
              }}
            >
              <span className="text-sm font-medium">{selectedLang}</span>
              <svg
                className="w-3 h-3"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d={isOpen ? "M5 15l7-7 7 7" : "M19 9l-7 7-7-7"}
                />
              </svg>
            </button>

            {isOpen && (
              <>
                <div
                  className="fixed inset-0 z-[9998]"
                  onClick={() => setIsOpen(false)}
                />
                <div
                  className="absolute top-full right-0 mt-1 bg-white border rounded-md shadow-lg min-w-[100px] z-[9999] overflow-hidden"
                  style={{ borderColor: "var(--hotel-primary-color)" }}
                >
                  <button
                    onClick={() => {
                      setSelectedLang("FR");
                      setIsOpen(false);
                    }}
                    className="w-full px-3 py-2 text-left text-sm hover:bg-gray-50 transition-colors block"
                    style={{
                      fontFamily: "var(--hotel-body-font-family)",
                      color: "var(--hotel-primary-color)",
                    }}
                  >
                    FR
                  </button>
                  <button
                    onClick={() => {
                      setSelectedLang("EN");
                      setIsOpen(false);
                    }}
                    className="w-full px-3 py-2 text-left text-sm hover:bg-gray-50 transition-colors block"
                    style={{
                      fontFamily: "var(--hotel-body-font-family)",
                      color: "var(--hotel-primary-color)",
                    }}
                  >
                    EN
                  </button>
                  <button
                    onClick={() => {
                      setSelectedLang("DE");
                      setIsOpen(false);
                    }}
                    className="w-full px-3 py-2 text-left text-sm hover:bg-gray-50 transition-colors block"
                    style={{
                      fontFamily: "var(--hotel-body-font-family)",
                      color: "var(--hotel-primary-color)",
                    }}
                  >
                    DE
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
